import { Box } from "@mui/material";
import { FC } from "react";
import { UseFormReturn } from "react-hook-form";
import { LabeledTextField, VerifyIconButton } from "../../../components";
import { useLocalization } from "../../../hooks/useLocalization";

interface WhitelistEmailFormProps {
  form: UseFormReturn<{ email: string }>;
  emailValue: string;
  emailError: string | undefined;
  onSubmit: (event: React.FormEvent) => void;
}

export const WhitelistEmailForm: FC<WhitelistEmailFormProps> = ({
  form,
  emailValue,
  emailError,
  onSubmit,
}) => {
  const { t } = useLocalization();

  return (
    <Box component="form" onSubmit={onSubmit}>
      <LabeledTextField
        InputProps={{
          endAdornment: (
            <VerifyIconButton
              disabled={!emailValue.trim() || !form.formState.isValid}
              type="submit"
            />
          ),
        }}
        borderRadius={1}
        containerSx={{ height: 68 }}
        error={!!emailError}
        fullWidth
        height={40}
        helperText={emailError}
        label={t("licenses.addToWhitelistDialog.email")}
        onPaste={() => form.formState.isValid}
        paddingRight={1}
        placeholder={t("licenses.addToWhitelistDialog.emailPlaceholder")}
        {...form.register("email")}
      />
    </Box>
  );
};
